import React from "react";
import { Form, InputGroup, Row, Col } from "react-bootstrap";
import { ButtonDanger } from "../../ui/templates/buttons";
import { DropdownForAssign } from "../../ui/templates/dropdown";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  IconButton,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

class Crew extends React.Component {
  render() {
    const {
      i,
      k,
      team,
      handleDeleteUserFromSlot,
      handlePayClick,
      handleGetInvoice,
      handleAssignPayment,
      renderNumberOption,
      findByRole,
    } = this.props;
    const count = k + 1;
    const crewName = i.first_name
      ? i.first_name + " " + i.last_name
      : "Crew No# " + count;
    return (
      <div key={k}>
        <Form.Group>
          <Accordion style={{ boxShadow: "none" }}>
            <AccordionSummary
              expandIcon={
                <IconButton className="expandIcon">
                  <ExpandMore />
                </IconButton>
              }
              aria-controls="panel1a-content"
              id="panel1a-header"
              style={{
                background: "#f7f7f7",
                border: "1px solid #d4d2d2",
              }}
            >
              <Form.Label className="bold">{crewName}</Form.Label>
            </AccordionSummary>
            <AccordionDetails>
              <Box width="100%">
                <Row>
                  <Col md={6}>
                    <Form.Group as={Row}>
                      <Box className="col-md-12">
                        <Form.Label className="InputformLabel">Name</Form.Label>
                        <Box className="inputWidth">
                          <Form.Control
                            disabled
                            type="text"
                            placeholder="Name"
                            value={
                              i.first_name
                                ? i.first_name + "" + i.last_name
                                : ""
                            }
                            name="name"
                          />
                        </Box>
                      </Box>
                    </Form.Group>

                    <Form.Group as={Row}>
                      <Box className="col-md-12 cta-email">
                        <Form.Label className="InputformLabel">
                          Email
                        </Form.Label>
                        <Box inputWidth>
                          <InputGroup>
                            <Form.Control
                              disabled
                              type="text"
                              placeholder="Email"
                              value={i.email}
                              name="email"
                            />
                            <Box mt="6px">
                              <InputGroup.Append>
                                {i.email && !findByRole(team) ? (
                                  <ButtonDanger
                                    text="Reject"
                                    onClick={() =>
                                      handleDeleteUserFromSlot(i.id)
                                    }
                                  />
                                ) : (
                                  <ButtonDanger text="Reject" disabled={true} />
                                )}
                              </InputGroup.Append>
                            </Box>
                          </InputGroup>
                        </Box>
                      </Box>
                    </Form.Group>

                    <Form.Group as={Row}>
                      <Box className="col-md-12">
                        <Form.Label className="InputformLabel">
                          Driver/crew
                        </Form.Label>
                        <Box>
                          <Form.Control
                            disabled
                            type="text"
                            placeholder="Driver/crew"
                            value={i.type}
                            name="Driver/crew"
                          />
                        </Box>
                      </Box>
                    </Form.Group>
                  </Col>
                  <Col md={6} className="pr-0 cta-payment-buttons">
                    <Box
                      className="formButtonDanger"
                      display="flex"
                      flexDirection="column"
                      alignItems={{ sm: "baseline", lg: "end", md: "end" }}
                    >
                      <Form.Group>
                        {i.payment_info === null ? (
                          <ButtonDanger
                            disabled={!i.is_payment_available}
                            text="Payment"
                            fullWidth
                            onClick={() => {
                              handlePayClick(i);
                            }}
                          />
                        ) : (
                          <ButtonDanger disabled={true} text="Paid" fullWidth />
                        )}
                      </Form.Group>

                      <Form.Group>
                        {i.payment_info !== null && i.email !== null ? (
                          <ButtonDanger
                            text="Tax Invoice"
                            fullWidth
                            onClick={() => handleGetInvoice(i.id)}
                          />
                        ) : (
                          <ButtonDanger
                            disabled={true}
                            text="Tax Invoice"
                            fullWidth
                          />
                        )}
                      </Form.Group>

                      <Form.Group>
                        {i.payment_info !== null &&
                        i.email !== null &&
                        !findByRole(team) ? (
                          <DropdownForAssign
                            id={i.id}
                            items={renderNumberOption(
                              team.team_slots.crews,
                              i.email
                            )}
                            onClick={handleAssignPayment}
                            text="Assign member"
                          />
                        ) : (
                          <ButtonDanger
                            disabled={true}
                            text="Assign member"
                            fullWidth
                          />
                        )}
                      </Form.Group>
                    </Box>
                  </Col>
                </Row>
              </Box>
            </AccordionDetails>
          </Accordion>
        </Form.Group>
      </div>
    );
  }
}
export default Crew;
